export default __webpack_public_path__ + "static/media/151-rent.5b8e6cf0.png";